import {
  updateContactReleaseToAIL,
  getTransferEndpoints,
  getMiloDeeplink,
  updateCallbackStatus,
} from "../api/session-api";
import Emitter from "../emitter";
import storeRTK from "../store/storeRTK";
import { SessionEvent } from "../types/call.type";
import { updateNormalCallback, callbackReset } from "../actions/callback";
import { setCurrentSessionTab } from "../actions/session";
import { Callback } from "../types/callback.type";
import { addCallbackToHistoryAction } from "../connector/history";
import { CASE_STATES } from "../constants/constants";
import {
  STATE_CALLBACK,
} from "../amazon-connect/constants";
import { setSelectedTab } from "../actions/common";
import { notificationManager } from "../utils/NotificationManager";
import {
  API_CALLBACK_UPDATE,
  API_MILO_CALLBACK_CHANNEL_TRANSACTION,
  UPDATE_CALLBACK_STATUS,
  STATE_MISSED_CALLBACK,
} from "../constants/events";
import { addNotificationAction } from "../connector/notifications";
import { createMissedCallbackNotification } from "../actions/notifications";
import { showErrorToast } from "../utils/utils";
import { callbackPlayer } from "../amazon-connect/handlers/callback";

function callbackHandler(event: SessionEvent<Callback>) {
  if (event.body?.self?.callback?.state) {
    if (event.body?.self?.callback?.state === CASE_STATES.RELEASED) {
      const cstate = storeRTK.getState();
      if (cstate.callback?.id === event.body?.id) {
        storeRTK.dispatch(addCallbackToHistoryAction(event.body));
        storeRTK.dispatch(callbackReset());
        notificationManager.stopFaviconBlinking();
      }
      updateContactReleaseToAIL("callback", event.body?.id as string);
    } else if (event.body?.self?.callback?.state === "TERMINATED") {
      storeRTK.dispatch(callbackReset());
      notificationManager.stopFaviconBlinking();
    } else if (event.body) {
      //TODO: Find better solution for this
      if (event.body.selfState !== CASE_STATES.ESTABLISHED) {
        storeRTK.dispatch(setCurrentSessionTab({ id: "callback" }));
        storeRTK.dispatch(setSelectedTab("Callback"));
      }

      const cstate = storeRTK.getState();
      const callbackNotPresent = !cstate.callback.id;

      storeRTK.dispatch(updateNormalCallback(event.body));

      if (callbackNotPresent) {
        if (event.body?.self?.callback?.state === CASE_STATES.RINGING) {
          notificationManager.startFaviconBlinking();
          const callback = storeRTK.getState().callback;
          notificationManager.show("You have an incoming callback", {
            body: "Click or open iHub to answer it",
            icon: "icon.png",
            onclick: () => {
              Emitter.emit(API_CALLBACK_UPDATE, {
                body: {
                  participantId: callback.self?.id,
                  conversationId: callback?.id,
                  state: "connected",
                },
              });
            },
          });
        }
      } else {
        if (cstate.callback.self?.callback?.state != "RINGING") {
          notificationManager.stopFaviconBlinking();
        }
      }
    }
  }
}

export async function contactEstablished(contactId: string | undefined) {
  if (contactId) {
    try {
      getTransferEndpoints(contactId);
    } catch (e: any) {
      console.log(
        "Error getting contact Established API during channel callback",
        e.message
      );
    }
  } else {
    console.log("Error: error in setting transfer endpoints");
  }
}

async function miloHandlerEvent(ev: SessionEvent<any>) {
  const miloEvent = {
    body: {
      contactId: ev.body.contactId,
    },
  };
  notificationManager.triggerMilo(miloEvent, "callback");
}

// Milo redirect to CRM
export async function miloHandlerForCallback(
  ev: SessionEvent<{ contactId: string | undefined }>
) {
  const miloDeeplink = await getMiloDeeplink("callback", ev.body?.contactId);
  if (miloDeeplink) {
    setTimeout(() => {
      window.open(miloDeeplink, "_blank");
    }, 100);
  }
}

const missedCallbackHandlerEvent = (ev: SessionEvent<any>) => {
  console.log("Missed callback event: ", ev);
  
  const eventData = ev.body;
  
  // Create missed callback notification
  const notification = createMissedCallbackNotification(
    eventData.contactId,
    eventData.customerName,
    eventData.phoneNumber,
    eventData.scheduledTime
  );
  
  // Dispatch the notification to the Redux store
  storeRTK.dispatch(addNotificationAction(notification));

  // Also display a persistent toast notification
  showErrorToast("You have missed a callback for " + eventData.customerName + " (" + eventData.phoneNumber + "), in queue " + eventData.queueName + ".", "missedCallbackNotification", 1*60*60*1000); // 1 hour
};

export default function registerCallbackHandlers() {
  Emitter.on(STATE_CALLBACK, callbackHandler);
  Emitter.on(API_MILO_CALLBACK_CHANNEL_TRANSACTION, miloHandlerEvent);
  Emitter.on(UPDATE_CALLBACK_STATUS, async (ev: SessionEvent<any>) => {
    try {
      const state = storeRTK.getState();
      const contactId = ev?.body?.contactId || state?.callback?.id || "";
      const phoneNumber = ev?.body?.phoneNumber || state?.callback?.self?.callback?.callbackNumber || "";
      const status = ev?.body?.status || "FAILED";
      const message = ev?.body?.message || "Invalid Number";
      if (contactId && phoneNumber) {
        await updateCallbackStatus(contactId, phoneNumber, status, message);
      } else {
        console.log("UPDATE_CALLBACK_STATUS missing contactId or phoneNumber");
      }
    } catch (error) {
      console.log("Error handling UPDATE_CALLBACK_STATUS", error);
    }
  });

  Emitter.on(STATE_MISSED_CALLBACK, missedCallbackHandlerEvent); // For missed callback notification  
}
